import { Army, Nullable, TeamArmy } from '@Models';
import { v4 as uuidv4 } from 'uuid';

export class TeamArmyView {
  id: Nullable<string>;
  item: Nullable<TeamArmy>;
  army: Nullable<Army>;
  armyId: number;
  name: string;
  logo: Nullable<string>;
  playerName: string;
  selectable: boolean;
  selected: boolean;

  constructor(params: TeamArmyViewParams) {
    this.id = params.id;
    this.item = params.item;
    this.army = params.army;
    this.armyId = params.armyId;
    this.name = params.armyName;
    this.logo = params.armyLogo;
    this.playerName = params.playerName;
    this.selectable = params.selectable;
    this.selected = params.selected;
  }

  public static fromArmy(
    item: Army,
    selectable: boolean = false,
    selected: boolean = false,
  ): TeamArmyView {
    return new TeamArmyView({
      id: null,
      item: null,
      army: item,
      armyId: item.id,
      armyName: item.name,
      armyLogo: item.medium_logo,
      playerName: '',
      selectable: selectable,
      selected: selected,
    });
  }
  public static empty(): TeamArmyView {
    return new TeamArmyView({
      id: null,
      item: null,
      army: null,
      armyId: -1,
      armyName: '',
      armyLogo: null,
      playerName: '',
      selectable: false,
      selected: false,
    });
  }

  public static fromTeamArmy(
    item: Nullable<TeamArmy>,
    selectable: boolean = false,
    selected: boolean = false,
  ): Nullable<TeamArmyView> {
    if (!item) return null;

    return new TeamArmyView({
      id: item.id,
      item: item,
      army: null,
      armyId: item.armyId,
      armyName: item.name,
      armyLogo: item.logo,
      playerName: item.playerName,
      selectable: selectable,
      selected: selected,
    });
  }

  public toTeamArmy(teamId: string): TeamArmy {
    return {
      id: uuidv4(),
      teamId: teamId,
      armyId: this.armyId,
      name: this.name,
      logo: this.logo,
      playerName: this.playerName,
      isUsed: false,
    } satisfies TeamArmy as TeamArmy;
  }
}

export type TeamArmyViewParams = {
  id: Nullable<string>;
  item: Nullable<TeamArmy>;
  army: Nullable<Army>;
  armyId: number;
  armyName: string;
  armyLogo: Nullable<string>;
  playerName: string;
  selectable: boolean;
  selected: boolean;
};
